'use strict';

import React from 'react';
import BusinessBrief from './BusinessBriefComponent';
import BusinessMediaList from './BusinessMediaListComponent';
import PostCardComponent from './PostCardComponent'
import API from 'sources/API';
import UserStore from 'stores/UserStore';
import UserActions from 'actions/UserActions';
import AlbumActions from 'actions/AlbumActions';
import AlbumStore from 'stores/AlbumStore';
import Navigator from './NavigatorComponent';

require('styles/AgentArticle.scss');

class AgentArticleComponent extends React.Component {
  constructor(props) {
    super(props);
    let albumStore = AlbumStore.getState()
    let userStore = UserStore.getState()
    this.state = {
      agent: userStore.agent,
      album: albumStore.album,
      albumMedia: albumStore.albumArticleMedia,
      isCollect: albumStore.album.isCollect,
      totalPrice: albumStore.totalPrice,
      paySignature: albumStore.paySignature,
      product: null,
      isAuthor: false,
      loading: true,
      hasMore: true,
      showNavigator: false,
      showPostCard: false,
      isShare: false,
      agent: {},
      oauth: false,
      isShare: false
    }
    this.onAlbumChange = this.onAlbumChange.bind(this)
    this.onAgentChange = this.onAgentChange.bind(this)
    this.checkOauth = this.checkOauth.bind(this)
    this.togglePostCard = this.togglePostCard.bind(this)
  }
  componentDidMount() {
    this.checkOauth()
    if(API.isWechat){
      fetch(API.getWechatConfig).then(res=>res.json()).then(json=>{
        if(json.appId) {
            window.wx.config(json);
        }
      })
    }

    AlbumStore.listen(this.onAlbumChange)
    UserStore.listen(this.onAgentChange)
    AlbumActions.cleanAlbumMedia();
    UserActions.fetchAgent(this.props.params.aid)
    AlbumActions.fetchAlbumDetail(this.props.params.id);
    AlbumActions.fetchAlbumArticleMedia(this.props.params.id)

    // Baidu tongji
    window._hmt.push(['_trackPageview', this.props.location.pathname]);
  }
  componentWillMount(){
    let { query } = this.props.location;
    if(query.type === 'share'){
      this.setState({isShare:true});
    }
  }
  onAgentChange(agent){
    this.setState({
      agent: agent.agent
    })
  }
  componentWillUnmount() {
    AlbumStore.unlisten(this.onAlbumChange)
    UserStore.unlisten(this.onAgentChange)
  }
  onAlbumChange(state){
    let album = state.album
    let albumArticleMedia = state.albumArticleMedia
    if(album && albumArticleMedia.length){
      album.cover = albumArticleMedia[0].images.big[0].replace('!li750','')
    }
    this.setState({
      album: album,
      product: state.album.product,
      albumMedia: albumArticleMedia,
      totalPrice: state.totalPrice,
      paySignature: state.paySignature,
      isCollect: state.album.isCollect || false,
      isAuthor: state.album.isAuthor || false,
      loading: state.loading,
      hasMore: state.moreAlbumMedias
    });

    let albumName = state.album.name;
    let brandName = this.state.agent.agent_name;
    let cover = state.albumArticleMedia[0]?state.albumArticleMedia[0].images.big[0]:"";
    window.wx.ready(()=>{
      window.wx.onMenuShareTimeline({
        title: `${albumName}-${brandName}`,
        link: `${location.href.split('?')[0]}?type=share`,
        imgUrl: encodeURI(cover||'https://img.xiaodiqiu.cn/share.png')
      });
      window.wx.onMenuShareAppMessage({
        title: `${albumName}-${brandName}`,
        desc: `分享一篇${brandName}美文——${albumName}。加入${brandName}，发现有趣的地方`,
        link: `${location.href.split('?')[0]}?type=share`,
        imgUrl: encodeURI(cover||'https://img.xiaodiqiu.cn/share.png'),
        type: 'link'
      });
    });

    // SEO 优化
    let title = albumName;
    let desc = this.state.album.desc;
    window.changeMetaForSEO(title,desc);
  }
  checkOauth(){
    let sendData = {
      article_id: this.props.params.id,
      agent_id: this.props.params.aid
    }
    let param = {
      method: 'POST',
      body: JSON.stringify(sendData),
      headers: API.jsonHeader
    }
    fetch(`${API.getAgentCheckOAuth}`,param).then(res=>res.json()).then(json=>{
      if(json.status == 0){
        let oauth = json.result
        this.setState({
          oauth: oauth
        })
      }
    });
  }
  togglePostCard(){
    this.setState({
      showPostCard: !this.state.showPostCard
    })
  }
  handleTextChange(event) {
    let state = {};
    state[event.target.name] = event.target.value;
    this.setState(state);
  }
  render(){
    let business = {
      agent_id: this.props.params.aid,
      name: this.state.agent.agent_name,
      small_avatar: this.state.agent.agent_small_avatar,
      summary: this.state.agent.agent_desc,
      ad_url: this.state.agent.agent_ad_url
    }
    let navigator;
    if(!this.state.isShare){
      navigator = <Navigator action='left' number={2} />
    }else{
      navigator = <Navigator action='home' path={'/agent/' + this.props.params.aid} number={2} />
    }

    let postCardReveal;
    if(this.state.showPostCard&&this.state.album._id){
      const texts = this.state.album.name.split('|')
      postCardReveal = <PostCardComponent
                         title = {texts[0]}
                         desc = {texts[1]}
                         cover = {this.state.album.cover}
                         togglePostCard = {this.togglePostCard}
                       />
    }
  	return (
  	  <div className="Agent-Article-component">
        {this.state.oauth?(
          <BusinessBrief
            article={this.state.album}
            count={this.state.albumMedia.length}
            isAuthor={this.state.isAuthor}
            business={business}
          />
        ):null}
        {this.state.oauth?(
          <div className="content">
            <BusinessMediaList
              medias={this.state.albumMedia}
              watermark={business.name}
              product={this.state.product}
              view_article={this.state.album.view_article}
              ad_url={business.ad_url}
            />
          </div>
        ):null}
        {postCardReveal}
        <Navigator action='share' number={3} callback={this.togglePostCard} />
        <Navigator action='top' />
        {navigator}
  	  </div>
  	)
  }
}

AgentArticleComponent.displayName = 'AgentArticleComponent';

export default AgentArticleComponent;



// WEBPACK FOOTER //
// ./src/components/AgentArticleComponent.js